import { ReleaseEntityV1alpha1 } from '@agilelab/plugin-wb-builder-common';
import { Skeleton } from '@material-ui/lab';
import { FC, useMemo } from 'react';
import { entitySupportsReverseProvisioning } from '../../../utils';
import { EditButton } from '../../common';
import { useEditorPageContext } from '../context/useEditorPageContext';
import { NewSnapshotButton } from '../NewSnapshotButton';
import { UpdateButton } from '../UpdateButton';
import ImportButton from './ImportButton';
import { WbCardActions } from '@agilelab/plugin-wb-platform';

export const EditorCardActions: FC = () => {
  const {
    entity,
    releases,
    fetchReleaseState,
    parent,
    descriptorStateWithComponents,
  } = useEditorPageContext();
  const showImport = entitySupportsReverseProvisioning(entity);

  // snapshot creation is disabled if there is already a snapshot
  const snapshot = useMemo(() => {
    return releases?.find((r: ReleaseEntityV1alpha1) => r?.metadata.isSnapshot);
  }, [releases]);

  return (
    <WbCardActions breakpoint="w_xs">
      {fetchReleaseState.loading ? (
        <Skeleton width={100} />
      ) : (
        <>
          {showImport && (
            <ImportButton
              entity={entity}
              disabled={descriptorStateWithComponents.loading}
            />
          )}
          <EditButton
            entity={entity}
            variant="outlined"
            disabled={descriptorStateWithComponents.loading}
          />
          {!parent && (!snapshot ? <NewSnapshotButton /> : <UpdateButton />)}
        </>
      )}
    </WbCardActions>
  );
};
